import React from "react";
import ChangeEmailForm from "./ChangeEmailForm";
import UpdatePasswordForm from "./UpdatePasswordForm";

const SignInMethod: React.FC = () => {
  return (
    <div className="row">
      <ChangeEmailForm />
      <UpdatePasswordForm />
    </div>
  );
};

export { SignInMethod };
